export default "__VITE_PUBLIC_ASSET__d9a90be5__"